import createIcon from '../../createIcon';

/**
 * @component @name Ninek
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNOCAxMEg5LjVWMTEuNUg4VjEwWk0xOSAzSDVDMy45IDMgMyAzLjkgMyA1VjE5QzMgMjAuMSAzLjkgMjEgNSAyMUgxOUMyMC4xIDIxIDIxIDIwLjEgMjEgMTlWNUMyMSAzLjkgMjAuMSAzIDE5IDNaTTExIDE0QzExIDE0LjU1IDEwLjU1IDE1IDEwIDE1SDYuNVYxMy41SDkuNVYxMi41SDcuNUM2Ljk1IDEyLjUgNi41IDEyLjA1IDYuNSAxMS41VjEwQzYuNSA5LjQ1IDYuOTUgOSA3LjUgOUgxMEMxMC41NSA5IDExIDkuNDUgMTEgMTBWMTRaTTE4IDE1SDE2LjI1TDE0LjUgMTIuNzVWMTVIMTNWOUgxNC41VjExLjI1TDE2LjI1IDlIMThMMTUuNzUgMTJMMTggMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Ninek = createIcon('Ninek', [
  [
    'path',
    {
      d: 'M8 10H9.5V11.5H8V10ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM11 14C11 14.55 10.55 15 10 15H6.5V13.5H9.5V12.5H7.5C6.95 12.5 6.5 12.05 6.5 11.5V10C6.5 9.45 6.95 9 7.5 9H10C10.55 9 11 9.45 11 10V14ZM18 15H16.25L14.5 12.75V15H13V9H14.5V11.25L16.25 9H18L15.75 12L18 15Z',
      key: '1t1f0b',
    },
  ],
]);

export default Ninek;
